
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer, useRef } from "react";
import { connect, useDispatch } from "react-redux";
// import FileBase64 from 'react-file-base64';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

import PropTypes, { object } from "prop-types";
import clsx from "clsx";
import moment from "moment";
// import {  } from "@material-ui/core";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import DownloadIcon from "@mui/icons-material/Download";

import {
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Grid,
  FormGroup,
  IconButton,
} from "@material-ui/core"; // Remove the unused imports for CHG0073013
import { useParams } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { MdReplay } from "react-icons/md";
import {
  CustomDatePicker,
  CustomFormGroup,
  CustomSelect,
  ValidatingTextField,
} from "../FormComponents";
import {
  DATE_FORMAT,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  Regex
} from "../../constants";
import { API } from "../../apis/api";
import { buildErrorMessage } from "../../apis/calls";
import Table from "../Table/Table";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { AuthChecker, Button } from "../../atomicComponents";
import { withAllowedOperationsProvider } from "../../hocs";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import styles from "./BulkSpoc.module.css";
import { setLogin } from '../../redux/features/auth/actions';
import Truckloading from "../CvLoader/Cvloader";
import { downloadFileFromUrl } from "../../utils/utils";


const initialState = {
  selectredio: null,
  dropDownValue: null,
  selectedFile: null,
  selectedPO: null,
};
const reducer = (state, action) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        [action.field]: action.value,
      };
    case "reset":
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

function SpocForm({baseUrl, auth }) {
  const { parameter } = useParams();
  const [dropDownValue, setDropDownValue] = useState([]);
  const[disbaledButton,setDisabledButton]=useState(true)
  const dispatchNew= useDispatch();

const RadioFlag = dropDownValue.value === "SPOC Upload / Delete - SA" ? 'BS' : 'BL';
console.log("RadioFlag: ", RadioFlag);

  useEffect(() => {
    if (parameter === "BL") {
      setDropDownValue({
        value: "Bulk Linkage / Delinkage",
        label: "Bulk Linkage / Delinkage",
      });
      setTableData([]);

      setSelectedFile(null);

      if (inputRef == null) {
        setSelectedFile(null);
      }
      setOnChange(true);
    } else if (parameter === "BS") {
      setDropDownValue({
        value: "SPOC Upload / Delete - SA",
        label: "SPOC Upload / Delete - SA",
      });
      setTableData([]);

      setSelectedFile(null);

      if (inputRef == null) {
        setSelectedFile(null);
      }
      setOnChange(true);
    }
  }, [parameter]);

  const inputRef = useRef(null);
  const ROW_HEIGHT = 38;
  const [rowsData, setRowsData] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
  const [poData, setPOData] = useState({
    loading: false,
    data: [],
    filteredData: [],
    last: false,
    number: 0,
  });
  const [state, dispatch] = useReducer(reducer, initialState);
  const { showPopup } = usePopupManager();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmModalFlag2, setConfirmModal2] = useState(false);
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);
  const [hover, setHover] = useState({ isHover: false, name: null });
  const [bodyBuilderOption, setBdybuilderOption] = useState([]);
  const [chassisOption, setChassisData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [asnCount, setAsnCount] = useState(0);
  const [companyCodeOption, setCompanyCode] = useState([]);
  const [myState, setState] = React.useState({
    checkFlag: false,
    tabelFlag: false,
  });

  /* SPOC Form States */

  const [ticketNo, setTicketNo] = useState("");
  const [bcName, setBcName] = useState("");
  const [bu, setBu] = useState("");
  const [barrel, setBarrel] = useState("");
  const [projDescp, setProjDescp] = useState("");
  const [type, setType] = useState([
    { value: "Bulk Linkage / Delinkage", label: "Bulk Linkage / Delinkage" },
    { value: "SPOC Upload / Delete - SA", label: "SPOC Upload / Delete - SA" },
  ]);
  const [onChange, setOnChange] = useState(false);
  const [selectredio, setSelectRedio] = useState();
  const [loadingTruck, setLoadingTruck] = React.useState(false);

  /* SPOC SELECTION DROPDOWN */

  /* Handle Select State Query */
  const handleSelectionQuery = (setState) => (valueObject) => setState(valueObject);
  const [radiostate, setRadioState] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    if((selectedFile === null || selectedFile !== '') && (selectredio === '' || selectredio === undefined)){
      setDisabledButton(true);
    }else if((selectedFile !== null) && (selectredio !== '' || selectredio !== undefined)){
      setDisabledButton(false)
    }else{
      setDisabledButton(true);
    }
  }, [selectedFile, selectredio]);

  const handleFileChange = (e) => {
    var FileUploadCtrl = e.target.files[0];
    if(FileUploadCtrl == undefined || FileUploadCtrl == ''){
    showPopup({
      type: MESSAGE_TYPE.INFORMATION,
      contextText: MESSAGE_TYPE.INFORMATION,
      info: "Please select File",
    });
    inputRef.current.value = null;
    setSelectedFile(null);
    }
    else{
    var FilePath = FileUploadCtrl.name;
    console.log("FilePath....",FilePath)
    var Ext = FilePath.substring(FilePath.lastIndexOf('.') + 1).toLowerCase();
    // if (Ext == "xls" || Ext == "xlsx")
    if (Ext !== "xlsx")
    {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select Excel File type",
      });
      inputRef.current.value = null;
      setSelectedFile(null);
    }  
    else{
      setSelectedFile(e.target.files[0]);
    }
  }
  };

  const handleRadioSelectionChange = (event) => {
    setSelectRedio(event.target.value);
     setDisabledButton(true)
  };

  const handleDownload = async () => {

    let fileName = "";
    if(RadioFlag === "BS"){
      fileName = "template_upload.xlsx";
    }else{
      fileName = "linkage_delinkage_template.xlsx";
    }

    try{
      let finalURL = `${baseUrl}reports/GetDocumentView`;
      let payload = {
        "path":fileName
      }
      var payloadString = JSON.stringify(payload);
      let headerss = new Headers();
      const ress = await fetch(finalURL, {
        method: "POST",
        headers: headerss,
        credentials:'include',
        body: payloadString,
      });
      const response = await ress.json();

      // console.log("response---> ", response);

      if(response.url){
        await downloadFileFromUrl(response.url, fileName);
        }
        else{
         setLoadingTruck(false)
         showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "failed to download",
        });
         
       }
    }
    catch(error){
      setLoadingTruck(false)
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Failed",
      });
    }
  
  };

  
  const handleCancel = () => {
    // setDropDownValue("");
    setSelectedFile(null);
    setSelectRedio(null);
    setTableData([]);
    setState((prvState) => ({ ...prvState, tabelFlag: false }));
    // setOnChange(false);
    inputRef.current.value = null;
    setDisabledButton(true)
  };

  const vlaidateURL = () => {
    console.log("selectredio, selectedFile", selectredio, selectedFile);

    let test = dropDownValue.value;
    if (test == "SPOC Upload / Delete - SA") {
      handleSubmit("bulkSpocupload");
    } else if (test == "SPOC Upload / Delete - SA") {
      handleSubmit("bulkSpocdelete");
    } else if (test == "Bulk Linkage / Delinkage") {
      handleSubmit("bulklinkage");
    } else if (test == "Bulk Linkage / Delinkage") {
      handleSubmit("bulkdlinkage");
    } else {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select upload type",
      });
    }
  };

  const handleSubmit = async (url) => {
    console.log("selectredio, selectedFile", url, selectredio, selectedFile);
    try{
      setLoadingTruck(true)
      const postData = new FormData();
      postData.append("file", selectedFile);
      let finalURL = "";
      if (url === "bulklinkage" && selectredio === "upload") {
        finalURL = `${baseUrl}master/bulklinkage`;
      } else if (url === "bulklinkage" && selectredio === "delete") {
        finalURL = `${baseUrl}master/bulkdlinkage`;
      } else if (url === "bulkSpocupload" && selectredio === "spoc_upload") {
        finalURL = `${baseUrl}master/bulkSpocupload`;
      } else if (url === "bulkSpocupload" && selectredio === "spoc_delete") {
        finalURL = `${baseUrl}master/bulkSpocdelete`;
      }
      let headerss = new Headers();
      const ress = await fetch(finalURL, {
        method: "POST",
        headers: headerss,
        credentials:'include',
        body: postData,
      });
      dispatchNew(setLogin({...auth, recentStatus: ress.status}))
      const finalData = await ress.json();
      if(finalData.msg === "Success" ){
        setDisabledButton(true)
        setLoadingTruck(false)
        setState((prvState) => ({ ...prvState, tabelFlag: true }));
        let tDta = [];
        if (finalData.data["error"] !== null) {
          tDta = finalData.data.error.map(
            ({ cost_center, inserted_by, person_no, project_code, remarks, start_date, end_date}) => {
              let startDate =  start_date === null ? '' : start_date;
              let endDate =  end_date === null ? '' : end_date;
              return (
                RadioFlag === "BS" ? {
              person_no,
              project_code,
              cost_center,
              inserted_by,
              remarks,
            }:
            {
              person_no,
              project_code,
              cost_center,
              startDate,
              endDate,
              inserted_by,
              remarks,
            }
            )
          }
          );
        }
        setTableData(tDta);
        inputRef.current.value = null;
        setSelectedFile(null);
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: MESSAGE_TYPE.SUCCESS,
          info: finalData.data.returnmsg,
          // reloads: true, // Set reload to true or false based on your condition
        });
       
       } 
        else if(finalData.msg==="Fail"){
         setLoadingTruck(false)
         showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: finalData.data,
          // reloads: true, // Set reload to true or false based on your condition
        });
         
       }
    }
    catch(error){
      setLoadingTruck(false)
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: "Failed",
        
      });
    }
  
  };

  const exportExcel = async (excelRowData) => {
    var fileTypel =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    var fileExt = ".xlsx";
    var fileName = "Report" + moment().format("DD/MM/YYYY LT");

    const ws = XLSX.utils.json_to_sheet(excelRowData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { booktype: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileTypel });
    FileSaver.saveAs(data, `${fileName}${fileExt}`);
  };

 

  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false,
  });
  const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } =
    backgroundColors;

  const changeBackgroundColor = (field) =>
    setBackgroundColors((prev) => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field) newBackgroundColors[key] = true;
        else newBackgroundColors[key] = false;
      }
      return newBackgroundColors;
    });

  
  const handleOpen = () => setIsPopupOpen(true);
  const handleClose = () => setIsPopupOpen(false);

  const resetFields = () => {
    setBcName(null);
    setBu(null);
    setBarrel(null);
    setProjDescp(null);
  };

  const renderOther1 = () => (
    <div
      className={styles.formGroup}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <Grid
        container
        spacing={2}
        style={{ marginTop: "2px" }}
        columns={12}
        className={styles.myGrid}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <CustomSelect
                isMandatory
                isMulti={false}
                isDisabled={true}
                className={clsx(styles.select, styles.sel2)}
                isClearable
                options={type}
                value={dropDownValue}
                onChange={(e) => {
                  setDropDownValue(e);
                  setTableData([]);
                  setSelectedFile(null);
                  if (inputRef == null) {
                    setSelectedFile(null);
                  }
                  inputRef.current.value = null;
                  setSelectedFile(null);
                  setDisabledButton(true)

                  setOnChange(true);

                }}
                name="type"
              />
            </div>
          </div>
        </Grid>
        {onChange === true && (
          <Grid item md={5} lg={5} sm={12}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv1)}>
                <div style={{ display: "flex", alignContent: "center", cursor: 'pointer'}}>
                  <label>Download Template</label>
                  <DownloadIcon
                    color="primary"
                    onClick={handleDownload}
                    style={{ marginLeft: "10px" }}
                  />
                </div>
              </div>

            </div>
            {myState.handoverDateFlag && (
              // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
              <div style={{ marginLeft: "35px" }} className={styles.error}>
                Inserted On is mandatory field
              </div>
            )}
          </Grid>
        )}
      </Grid>
    </div>
  );


  const renderOther = () => (
    <div
      className={styles.formGroup}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <Grid
        container
        spacing={3}
        columns={12}
        className={styles.myGrid}
      >
        <Grid item md={4} lg={4} sm={12}>

          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            markIfUnselected={highlightMandatoryFields}
            resetAllVisitedFields={resetAllVisitedFields}
            style={{
              // marginLeft: "21px",
              marginRight: "11px",
            }}
            value={selectredio == null ? null : selectredio}
            onChange={handleRadioSelectionChange}
            defaultValue=""
            // onClick={(e) => {
            //   // handleRadiobtn(e);
            //   setRadioState(e.target.value);
            //   setTableData([]);
            // }}
          >
      
            {dropDownValue.value === "SPOC Upload / Delete - SA" && (
              <>
                <FormControlLabel
                  value="spoc_upload"
                  name="SPOC Upload"
                  control={<Radio size="small" />}
                  label="SPOC Upload"
                  className={styles.radiobtn}
                />
                <FormControlLabel
                  value="spoc_delete"
                  name="SPOC Delete"
                  control={<Radio size="small" />}
                  label="SPOC Delete"
                  className={styles.radiobtn}
                />
              </>
            )}
            {dropDownValue.value === "Bulk Linkage / Delinkage" && (
              <>
                <FormControlLabel
                  value="upload"
                  name="Linkage Upload"
                  control={<Radio size="small" />}
                  label="Linkage Upload"
                  className={styles.radiobtn}               
                />
                <FormControlLabel
                  value="delete"
                  name="Linkage Delete"
                  control={<Radio size="small" />}
                  label="Linkage Delete"
                  className={styles.radiobtn}
                />
              </>
            )}
          </RadioGroup>
          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>

        <Grid item md={4} lg={4} sm={12}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv} style={{ paddingTop: "10px" }}>
              <input
                type="file"
                ref={inputRef}
                onChange={(e) => {
                  handleFileChange(e);
                }}
                id="upload-file"
                data-testid={`upload-file-${document.id}`}
                className={styles.contentfile}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div>
          </div>

          {myState.handoverDateFlag && (
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <div className={styles.contentfile}>
                <Button
                  className={clsx(styles.actionButton)}
                  variant="primary"
                  onClick={() => vlaidateURL()}
                  disabled={disbaledButton}
                  data-testid="confirm-action"
                  style={{ marginRight: "5px" }}
                >
                  Submit
                </Button>

                <Button
                  className={clsx(styles.actionButton, styles.resetButton)}
                  variant="tertiary"
                  onClick={handleCancel}
                  style={{ marginRight: "5px" }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>

          {myState.handoverDateFlag && (
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );

  const renderReport = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2} sm={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Employee Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10} sm={10}>
          <div className={styles.formDiv}>
            <TableSimple
              tableColumnData={tableData}
              tableHeaderLabel={RadioFlag === 'BS' ? 
                [
                  "Person No",
                  "Project Code",
                  "Cost Center",
                  "Inserted By",
                  "Remarks",
                ]
                :
                [
                  "Person No",
                  "Project Code",
                  "Cost Center",
                  "Start Date",
                  "End Date",
                  "Inserted By",
                  "Remarks",
                ]
              }
              TableRowHederAling="start"
              size="small"
              headerColor="#E6F2FF"
            ></TableSimple>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const getSelectedFields = () => ({
    selectredio: selectredio,
    dropDownValue: dropDownValue,
    selectedFile: selectedFile,
  });

  const validateFields = (fields) => {
    const requiredFields = { ...fields, ...fields.kamContactDetails };
    const hasMissingRequiredFields = Object.values(requiredFields).some(
      (field) => !field
    );

    const hasError = Object.values(errors).some((err) => err);

    if (hasMissingRequiredFields || hasError) {
      return false;
    }
    return true;
  };

  // const runPreSubmissionChecks = () => {
  //   const selectedFields = getSelectedFields();
  //   const areFieldsValid = validateFields(selectedFields);

  //   if (!areFieldsValid) {
  //     setHighlightMandatoryFields(true);
  //     // return false;
  //     return true;
  //   }
  //   return true;
  // };

  const resetAllInputs = () => {
    const inputs = {
      purchaseBuyerName: "",
      suppRepresentativeName: "",
      suppRepresentativeContact: "",
      suppRepresentativeEmail: "",
    };
    dispatch({ type: "update", field: "inputFields", value: inputs });
    dispatch({ type: "update", field: "errors", value: {} });
  };

  const resetState = () => {
    dispatch({ type: "reset" });
    resetAllInputs();
    resetTableData();
    setHighlightMandatoryFields(null);
    setResetAllVisitedFields(false);
    changeBackgroundColor("processInfoBg");
  };

  useEffect(() => {
    if (resetAllVisitedFields) resetState();
  }, [resetAllVisitedFields]);

  return (
    <>
      <div
        className={clsx(
          styles.scrollContainer,
          styles.scrollBar,
          styles.formContainer
        )}
      >
        <CustomFormGroup header="Bulk Upload / Delete" body={renderOther1()} />
        {onChange === true && <>{renderOther()}</>}
      
         {loadingTruck ? (
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
               <Truckloading />
            </div>):
               myState.tabelFlag && (
          // <CustomFormGroup header="Report Details" body={renderReport()} />
          <>{tableData.length > 0 && renderReport()}</>
        )}
      </div>
      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />
    </>
  );
}

function ResetModal2({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}
function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Are you sure you want to reset the filters?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose();
              resetFields();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

SpocForm.propTypes = {
  redirectToProcessPage: PropTypes.func,
};

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired,
};
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
ResetModal2.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
SpocForm.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(SpocForm);

export default withAllowedOperationsProvider(App, RESOURCE_TYPE.PPAP);